import { render, staticRenderFns } from "./SenateLanding.vue?vue&type=template&id=5a964acd&"
import script from "./SenateLanding.vue?vue&type=script&lang=js&"
export * from "./SenateLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports